export default __webpack_public_path__ + "static/media/cauliflowerbites-wide@2x.746458d1.jpg";